import { useOutletContext } from "react-router-dom";

export function useSiteContent() {
  return useOutletContext();
}